/**
 * @description Site-function options for the primary location (LYN-356)
 *
 * @notes Values match locations.functions. Empty is allowed (unset).
 */

export const LOCATION_FUNCTIONS = [
  { value: 'yard', label: 'Yard' },
  { value: 'dispatch', label: 'Dispatch' },
  { value: 'call_center', label: 'Call center' }
];
